import { html, LitElement, } from 'lit-element';
import { css } from 'emotion';
import '../../components/star-rating';

export class StarRatingBlock extends LitElement {
  createRenderRoot() {
    return this;
  }
  
  render() {
    return html`
      <div class="${this.basicStyles}">
        <div class="accordion-item">
          <div class="accordion-item-toggle" @click="${this.clickStarRating}">
            <div class="block-header star-rating-block">
              <span>별점 사용하기</span>
              
              <i class="f7-icons drop">chevron_down</i>
            </div>
          </div>

          <div class="accordion-item-content">            
            ${this.starTemplate(`편의제공`)}
            ${this.starTemplate(`시설관리`)}
            ${this.starTemplate(`서비스`)}
            ${this.starTemplate(`청결도`)}

            <hr />

            <div class="block score-block">
              <span>총점</span>
              <span class="total-score">0.0</span>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  starTemplate(name) {
    return html`
    <div class="block ${this.blockStyle()}">
      <span>${name}</span>
      <star-rating @change-event=${this.changeScore}></star-rating>
      <span class="score">0.0</span>
    </div>
    `;
  }

  changeScore(event) {
    const { target } = event;
    const totalScore = this.querySelector(`.total-score`);
    const calcurate = () => {
      const scores = this.querySelectorAll(`.score`);
      let sum = 0; 
      scores.forEach(score => {
        sum += +score.textContent;
      });

      return sum / 4;
    }

    target.nextElementSibling.textContent = event.detail.value;
    totalScore.textContent = calcurate();
  }

  blockStyle() {
    return css`
    & {
      display: flex;
      align-items: center;

      > span {
        margin: 10px;
      }

      > span:first-child {
        min-width: 50px;
      }

      > span:last-child {
        margin-left: auto;
      }
    }
    `;
  }

  clickStarRating() {
    const { currentTarget } = event;
    const icon = currentTarget.querySelector(`.drop`);
    const isOpen = () => currentTarget.closest(`.accordion-item-opened`);

    if (isOpen()) {
      icon.textContent = `chevron_up`;
      return;
    } 
    icon.textContent = `chevron_down`;
  };

  get basicStyles() {
    return css`
    hr {
      border-color: #fcfcfc;
      margin: 0 15px;
      opacity: 0.5;
      border-radius: 10px;
    }

    .score-block {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      > span {
        margin: 10px;
        font-weight: bold;
      }
    }
    `;
  }
}

customElements.define('star-rating-block', StarRatingBlock);